<template>
    <div class="modal fade " id="sendPOToVendorModal">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Send To Vendor</h5>
                    <button type="button" class="close" data-dismiss="modal"><i class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-12">
                            <label>Vendor email address:</label>
                            <div>
                                <!--<span class="text-primary" v-if="customer_contact">
                                    {{ customer_contact.email}}
                                </span>
                                <span class="text-primary" v-else-if="order.customer">
                                    {{ order.customer.customer_contacts && order.customer.customer_contacts.length ? order.customer.customer_contacts[0].email : order.customer.email}}
                                </span>-->
                                <!-- <input type="email" name="customer_email" v-model="vendor_email" class="form-control"> -->
                                <!-- <InputTag v-model="vendor_email" id="cc1" placeholder="Comma separated email addresses"
                                    :add-tag-on-blur="true"
                                    validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                            ></InputTag> -->
                            <v-select label="contact_email" :filterable="false" :multiple="true"
                                      v-model="vendor_email"
                                      :options="vendors"
                                      
                                      @search="onVendorSearch"
                                      >
                                <template slot="no-options">
                                    type to search vendors..
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center" v-html="option.html">
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center" v-html="option.text">
                                    </div>
                                </template>
                            </v-select>

                            </div>
                        </div>

                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between mt-1">
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addCC" v-on:click="toggleCC"><span class="lt-bl-bg"> {{isCC ? 'Remove CC' : 'Add CC'}}</span></a>
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addBCC" v-on:click="toggleBCC"><span class="lt-bl-bg"> {{isBCC ? 'Remove BCC' : 'Add BCC'}}</span></a>
                        </div>
                    </div>

                    <div class="form-group" v-if="isCC == true">
                        <label for="subject">CC</label>
                        <!--<input type="email" class="form-control" id="cc" placeholder="cc" v-model="cc">-->
                        <!-- <InputTag v-model="cc" id="cc" placeholder="Comma separated CC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag> -->

                         <v-select v-if="isCC" label="text" :filterable="false" :multiple="true" :taggable="true" :selectOnTab="true"
                              v-model="cc"
                              :options="systemUsers"
                              @search="onSystemUserSearch"
                              @input="onSystemUserSelect"
                              @selected="onSystemUserSelect"
                              @deselected ="onSystemUserDeSelect">
                        <template slot="no-options">
                            type to search vendors..
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center" v-html="option.html">
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center" v-html="option.html ? option.html : option.text">
                            </div>
                        </template>
                    </v-select>

                    </div>


                    <div class="form-group" v-if="isBCC == true">
                        <label for="bcc">BCC</label>
                        <!--<input type="email" class="form-control" id="bcc" placeholder="bcc" v-model="bcc">-->
                        <InputTag v-model="bcc" id="bcc" placeholder="Comma separated BCC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>


                    <div class="form-group">
                        <label for="subject">Subject</label>
                        <input type="text" class="form-control" id="subject" placeholder="" v-model="subject">
                    </div>

                    <div class="form-group">
                        <!--<label for="message_body">Hello</label>-->
                        <ckeditor v-model="message_body"
                                  tag-name="textarea"
                                  value="Hello, <p>Please Enter Message</p>"
                                  :config="editorConfigMin"></ckeditor>
                    </div>
                    <div class="form-group">
                        <label for="bcc">Deposit required?</label>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input value="1" v-model="order.is_deposit_required" type="radio" id="is_deposit_required1" name="is_deposit_required1" class="custom-control-input">
                            <label class="custom-control-label" for="is_deposit_required1">Yes</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input value="0" v-model="order.is_deposit_required" type="radio" id="is_deposit_required2" name="is_deposit_required2" class="custom-control-input">
                            <label class="custom-control-label" for="is_deposit_required2">No</label>
                        </div>
                        <!--<div class="form-check">
                            <input v-model="order.is_deposit_required" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">Is deposit required?</label>
                        </div>-->
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label>Attachments</label>
                        </div>
                        <div class="col-12">
                            <div class="pdf-dwn-sec line-hgt">
                                <span class="orderbtnsec">
                                    <a class="btn btn-primary" href="javascript:void(0)" @click="downloadPdf()">Download PO PDF</a>
                                </span>
                            </div>
                        </div>
                        <div class="col-12">
                            <!--<label for="attach">Add Attachment</label> <br>-->
                            <vue-dropzone :options="dropzoneOptions"
                                          :id="'item-dropzone-attach'"
                                          v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                            </vue-dropzone>
                        </div>

                        <div class="col-12" v-if="attachments.length > 0">
                            <template v-for="(item, index) in attachments">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{item.attach_link}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="download(item)">
                                            Download</a>

                                        <a href="javascript:void(0)" class="trash_btn"
                                           @click="deleteAttachmentFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                    </span>
                                </div>
                            </template>
                        </div>

                        <div class="col-12">
                            <template v-if="attached_files.length > 0">
                                <template v-for="(item, index) in attached_files">
                                    <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                        <img v-if="item.url && (item.file_ext.toLowerCase() == 'png' || item.file_ext.toLowerCase() == 'jpeg' || item.file_ext.toLowerCase() == 'jpg')"
                                             :src="item.url" style="width:70px;height:70px">
                                        {{item.filename}}
                                        <a href="javascript:void(0)" class="trash_btn"
                                           @click="deleteAttachFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                    </div>
                                </template>
                            </template>
                        </div>

                    </div>

                    <div class="mt-3">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="confirmSendToVendor">Send Mail</button>
                    </div>
                </div>

                <!-- Modal footer -->


            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InputTag from "vue-input-tag";
import Vue from "vue";

export default {
    name: "SendPurchaseOrderToVendor",
    components: {
        DatePicker,
        vueDropzone: vue2Dropzone,
        InputTag
    },
    props: ['order', 'vendor_contact'],
    created() {

    },
    beforeMount() {
         let email = null;
        if(this.vendor_email.length == 0) {
            if(this.vendor_contact) {
                email = this.vendor_contact.email;
            } else if(this.order.vendor) {
                email = this.order.vendor.contacts &&
                this.order.vendor.contacts.length ? this.order.vendor.contacts[0].email : this.order.vendor.email;
            }
        }
        if (email) {
            // this.vendors = [
            //     {  contact_email: email, html: email, text: email },
            //     // { contact_email:email},
            // ];
           // this.onVendorSearch(email, true);
            //this.vendor_email = [email];
        }

    },
    mounted() {
        let self = this;
        $("#sendPOToVendorModal").on('show.bs.modal', () => {
            self.getSendToCustomerSettings();
            self.attachments = _.cloneDeep(this.order.artworks);
        });
    },
    data() {
        return {
            systemUsers:[],
            vendors: [],
            submitted: false,
            isCC: false,
            media_id: null,
            media_ids: [],
            vendor_email: [],
            cc: [],
            isBCC: false,
            bcc: [],
            subject: null,
            message_body: "Hello, <p>Please Enter Message</p>",
            adminUser: null,
            smtp_user: null,
            attachments: [],
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 5,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            attached_files: []
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),

        onVendorSelect(event){
            //console.log(event)
            //this.form.vendor_id = [];
            // if (event.length) {
            //     event.forEach((item) => {
            //         if(!this.form.vendor_id.includes((item.id))) {
            //             this.form.vendor_id.push(item.id);
            //         }
            //     });
            // }

            // if(this.form.vendor_id.length) {
            //     let vendor = this.vendors.find((x) => x.id == this.form.vendor_id[0]);

            //     //console.log(vendor)

            //     if(vendor) {
            //         let contact_name = vendor.contact_name;
            //         let company_name = vendor.contact_email;

            //         //this.form.quote_subject = this.form.quote_subject.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', company_name)
            //         //this.form.quote_subject = this.form.quote_subject.replace('()', '');
            //         //this.form.message_body = this.form.message_body.replace('__VENDOR_NAME__', contact_name).replace('__VENDOR_COMPANY_NAME__', company_name);
            //         //this.form.message_body = this.form.message_body.replace('()', '');
            //     }
            // }
        },
        onVendorDeSelect(event){
            // this.form.vendor_id = [];
            // if (event.length) {
            //     event.forEach((item) => {
            //         if(!this.form.vendor_id.includes((item.id))) {
            //             this.form.vendor_id.push(item.id);
            //         }
            //     });
            // }
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        
                       
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
         onSystemUserSelect(event){
            //console.log(event)
            this.form.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.form.add_cc.includes((email))) {
                        this.form.add_cc.push(email);
                    }
                });
            }
        },
        onSystemUserDeSelect(event){
            this.form.add_cc = [];
            if (event.length) {
                event.forEach((item) => {
                    let email = item.email ? item.email : item.text;
                    if(!this.form.add_cc.includes((email))) {
                        this.form.add_cc.push(email);
                    }
                });
            }
        },
        onSystemUserSearch(search, loading) {
            if(search.length) {
                if(this.systemUsers.length == 0) {
                    loading(true);
                    this.searchSystemUser(loading, search, this);
                }

            }
        },
        searchSystemUser: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchSaleUser'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.systemUsers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        downloadPdf() {
            let url = window.route('po.download', {id: this.order.id});

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", "po_" + this.order.po_number + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSendToCustomerSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.sendToCustomer.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let po_number = this.order.po_number;

                        let contact_name = "";
                        let company_name = "";
                        if(this.order.vendor) {
                            company_name = this.order.vendor.company_name;
                            if(this.order.vendor.contacts && this.order.vendor.contacts.length) {
                                contact_name = this.order.vendor.contacts[0].contact_name;
                            }
                        }

                        this.adminUser = data.data.adminUser;
                        this.smtp_user = data.data.smtp_user;
                        this.subject = data.data.po_send_to_vendor_title.replace('__PO_NUMBER__', po_number);
                        this.subject = this.subject.replace('__VENDOR_NAME__', contact_name);
                        this.subject = this.subject.replace('__VENDOR_COMPANY_NAME__', company_name);

                        this.message_body = data.data.po_send_to_vendor_body.replace('__PO_NUMBER__', po_number);
                        this.message_body = this.message_body.replace('__VENDOR_NAME__', contact_name);
                        this.message_body = this.message_body.replace('__VENDOR_COMPANY_NAME__', company_name);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        confirmSendToVendor() {
            let self = this;
            if(this.order.po_status_id > 2) {
                Vue.$confirm({
                    title: 'Are you sure?',
                    message: `Are you sure you want to change PO status to "Sent to Vendor"?`,
                    button: {
                        yes: 'Yes',
                        no: 'Cancel'
                    },
                    callback: confirm => {
                        if (confirm) {
                            self.sendToVendor(true);
                        } else {
                            self.sendToVendor();
                        }

                    }
                });
            } else {
                this.sendToVendor();
            }
        },
        sendToVendor(downgrade_status = false) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('po.sendToVendor', {id: this.order.id}), {
                vendor_email: this.vendor_email,
                subject: this.subject,
                cc: this.cc,
                bcc: this.bcc,
                message_body: this.message_body,
                media_id: this.media_id,
                media_ids: this.media_ids,
                isCC: this.isCC,
                isBCC: this.isBCC,
                is_artwork_required: this.order.is_artwork_required,
                is_deposit_required: this.order.is_deposit_required,
                is_sample_required: this.order.is_sample_required,
                is_no_artwork: this.order.is_no_artwork,
                is_repeat_order: this.order.is_repeat_order,
                attachments: this.attachments,
                downgrade_status: downgrade_status
            }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit('sentPurchaseOrderToVendor')
                        $('#sendPOToVendorModal').modal('hide');
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        afterUploadComplete(file, response) {
            this.media_ids.push(response.data.media.id);
            let media = _.cloneDeep(response.data.media);
            media['url'] = response.data.url;
            this.attached_files.push(media);
        },
        deleteAttachFile(index){
            this.attached_files.splice(index, 1);
            this.media_ids.splice(index, 1);
        },
        toggleCC(){
          this.isCC = !this.isCC;
            if(!this.isCC) {
                this.cc = [];
            }
        },
        toggleBCC(){
            this.isBCC = !this.isBCC;
            if(!this.isBCC) {
                this.bcc = [];
            }
        },
        deleteAttachmentFile(index) {
            this.attachments.splice(index, 1);
        },
        download(media) {
            let url = window.route('medias.download', {
                path: 'po_attachments',
                id: this.order.id,
                name: media.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", media.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
